mutation UpdateProvenExpertLink($companyId: ID!, $provenExpertLink: String) {
  updateProvenExpertLink(
    input: { companyId: $companyId, provenExpertLink: $provenExpertLink }
  ) {
    company {
      provenExpertLink
    }
  }
}
